<template>
  <div class="box" :style="boxBackgroundStyle">
    <div class="box_header">
      <Text v-if="title" pattern="h5" :height="140" :weight="600">
        {{ $t(title, options) }}
      </Text>
      <Text v-if="subtitle" pattern="body3" :height="150" color="#787878">
        <div v-html="$t(subtitle)" />
      </Text>
    </div>

    <div class="box_footer">
      <div class="box_points" v-if="points && points?.length > 0">
        <div
          v-for="{ id, title, subtitle, options } in points"
          :key="id"
          class="box_point"
        >
          <Text v-if="title" :height="130" :weight="500">
            {{ $t(title, options) }}
          </Text>
          <Text v-if="subtitle" pattern="body3" :height="150" color="#787878">
            {{ $t(subtitle) }}
          </Text>
        </div>
      </div>
      <slot name="bottom" class="box_bottom" />
    </div>
  </div>
</template>

<script>
import { Text } from "@/shared/ui";
export default {
  name: "Box",
  components: { Text },
  props: {
    title: { type: String },
    subtitle: { type: String },
    points: { type: Array },
    img: { type: String },
    imgSize: { type: String },
    imgPosition: { type: String },
    imgRepeat: { type: String },
    options: { type: Object },
  },
  computed: {
    boxBackgroundStyle() {
      if (this.img) {
        return {
          backgroundImage: `url(${this.img})`,
          backgroundSize: this.imgSize || "cover",
          backgroundPosition: this.imgPosition || "center",
          backgroundRepeat: this.imgRepeat || "no-repeat",
        };
      }
      return {};
    },
  },
  data() {
    return {};
  },
  methods: {},
  watch: {},
  created() {},
};
</script>

<style lang="scss" scoped>
.box {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  padding: 16px 21px 17px;
  border-radius: 10px;
  background: var(--bg-2);
  border: 1px solid var(--btn-secondary);
  width: 100%;
  height: 100%;
  flex: 1;

  &_header {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 3px;
  }

  &_footer {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 28.64px;
    width: 100%;
  }

  &_points {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 10.98px;
  }

  &_point {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 1px;
  }
}
</style>
